import { useEffect } from "react";
import { useRouteError } from "react-router";
import { Sentry } from "./bugsink";

export default function ErrorPage() {
  const error = useRouteError();

  useEffect(() => {
    if (error instanceof Error) {
      Sentry.captureException(error);
    }
  }, [error]);

  return (
    <div>
      <h1>
        {error.status === 404 ? "404 Page Not Found" : "An error occurred"}
      </h1>
    </div>
  );
}
